import type { Action } from 'redux';

/**
 * @TODO: properly type this
 */
type GenericState = any;
type Reducer = (state: GenericState, action: Action) => GenericState;

const composeReducers =
    (...reducers: Reducer[]) =>
    (state: GenericState, action: Action) =>
        reducers.reduce((prevState, reducer) => reducer(prevState, action), state);

export default composeReducers;
